import { render, staticRenderFns } from "./CheckSummary.vue?vue&type=template&id=2956a6e0&scoped=true&"
import script from "./CheckSummary.vue?vue&type=script&lang=js&"
export * from "./CheckSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956a6e0",
  null
  
)

export default component.exports